var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper"},[_c('div',{staticClass:"row tooltip-wrapper"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-user fa-fw fa-lg"}),_vm._v(" "+_vm._s(_vm.$label("event.events", "Events"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('event.new_event', 'New event'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('event.new_event', 'New event'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewEvent' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeframeFilter),expression:"timeframeFilter"}],staticClass:"form-control header-select pull-right",staticStyle:{"margin-right":"15px"},attrs:{"id":"event-timeframe-select"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.timeframeFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.eventTimeframes),function(timeframe,index){return _c('option',{key:index,domProps:{"value":timeframe}},[_vm._v(_vm._s(timeframe))])}),0),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeFilter),expression:"typeFilter"}],staticClass:"form-control header-select pull-right",staticStyle:{"margin-right":"15px"},attrs:{"id":"event-type-select"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.typeFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.eventTypes),function(type,index){return _c('option',{key:index,domProps:{"value":type}},[_vm._v(_vm._s(type))])}),0)],1)])]),_c('input',{attrs:{"type":"hidden","id":"customer-display-all","value":"false"}}),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],staticClass:"mt-8",attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "event.events_failed_request", "Request failed while loading events." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"events-table","loading":_vm.loading,"columns":[
      {
        title: 'Event',
        field: 'name',
        id: function (row) { return ("event-name-" + (row.id)); },
        onClick: function (row) { return _vm.$router.push({
            name: 'EventDetails',
            params: { event_id: row.id }
          }); }
      },
      {
        title: 'Date',
        id: function (row) { return ("event-date-" + (row.id)); },
        value: function (row) { return ((_vm.dateObjectToString(
            new Date(row.start_date)
          )) + " - " + (_vm.dateObjectToString(new Date(row.end_date)))); }
      },
      {
        title: 'Bookable',
        id: function (row) { return ("event-bookable-" + (row.id)); },
        value: function (row) { return ((_vm.dateObjectToString(
            new Date(row.bookable_from)
          )) + " - " + (_vm.dateObjectToString(new Date(row.bookable_until)))); }
      },
      {
        title: 'Max. participants',
        id: function (row) { return ("event-max-participants-" + (row.id)); },
        value: function (row) { return ((row.max_participants) + " / ∞"); }
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'EventDetails',
            params: { event_id: row.id }
          });
        }
      },
      {
        icon: 'users',
        bgColor: 'primary',
        onClick: function () {
          //
        }
      },
      {
        icon: 'mobile',
        bgColor: 'primary',
        onClick: function () {
          //
        }
      },
      {
        icon: 'envelope-o',
        bgColor: 'primary',
        onClick: function () {
          //
        }
      },
      {
        icon: 'user-plus',
        bgColor: 'primary',
        onClick: function () {
          //
        }
      }
    ],"data":_vm.events,"meta":_vm.metaData,"selectable":""},on:{"onRowSelect":function () {},"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getEvents({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewEvent' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("event.new_event_long", "Create new event")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }